import "./style.css";
import { property as h } from "./index-s3jJ0xl5-CowEOooj-Bsetjq7R.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function a(t) {
  return h({ ...t, state: true, attribute: false });
}
export {
  a as state
};
